import React from 'react';
import { Shield, Chrome, CheckCircle2, Flag, UserCheck, Scale } from 'lucide-react';

const TrustExperience = () => {
  const features = [
    {
      icon: <UserCheck className="w-5 h-5" />,
      title: "Nous sommes ouverts à tous",
      description: "Tout le monde peut écrire un avis Trustpilot. Les auteurs d'avis peuvent les modifier ou les supprimer à tout moment."
    },
    {
      icon: <CheckCircle2 className="w-5 h-5" />,
      title: "Avis vérifiés",
      description: "Les entreprises peuvent utiliser nos invitations automatiques pour collecter des avis. Ils sont accompagnés du statut \"Vérifié\"."
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "Nous combattons les faux avis",
      description: "Nous avons des personnes dédiées et des technologies intelligentes pour nous aider à protéger notre plateforme."
    },
    {
      icon: <Flag className="w-5 h-5" />,
      title: "Nous encourageons les feedbacks constructifs",
      description: "Voici 8 conseils pour écrire des avis de qualité."
    },
    {
      icon: <UserCheck className="w-5 h-5" />,
      title: "Nous vérifions les auteurs d'avis",
      description: "La vérification permet de s'assurer que des personnes réelles écrivent les avis que vous lisez sur Trustpilot."
    },
    {
      icon: <Scale className="w-5 h-5" />,
      title: "Précautions anti-biais",
      description: "Offrir des incitatifs en échange d'avis ou demander des avis de manière sélective peut fausser le TrustScore."
    }
  ];

  return (
    <div className="bg-gray-50 py-12 mt-8">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-2xl font-bold text-[#1a1a1a] mb-2">L'expérience Trustpilot</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-lg p-5 shadow-sm">
              <div className="text-[#00b67a] mb-3">{feature.icon}</div>
              <h3 className="font-semibold text-[#1a1a1a] mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Browser Extension CTA */}
        <div className="mt-8 bg-white rounded-lg p-6 shadow-sm flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#1a1a1a] rounded-lg flex items-center justify-center">
              <svg viewBox="0 0 126 31" xmlns="http://www.w3.org/2000/svg" className="h-4 w-auto">
                <path fill="#00b67a" d="M33.3 13.6l-4.5 4.4 1.1 6.2-5.5-2.9-5.5 2.9 1.1-6.2-4.5-4.4 6.2-.9 2.8-5.6 2.8 5.6 6.2.9z"/>
              </svg>
            </div>
            <div>
              <p className="font-medium text-[#1a1a1a]">Découvrez si un site web est fiable sans quitter la page.</p>
            </div>
          </div>
          <a
            href="#"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#1a1a1a] text-white font-medium rounded hover:bg-[#333] transition-colors whitespace-nowrap"
          >
            <Chrome className="w-5 h-5" />
            Installer l'extension Chrome
          </a>
        </div>

        <div className="text-center mt-6">
          <a href="#" className="text-sm text-[#1a1a1a] font-medium hover:underline">
            En savoir plus
          </a>
        </div>
      </div>
    </div>
  );
};

export default TrustExperience;
